// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "-legacy." + {"216":"3d5e2145","432":"adc5c326","787":"2e12cbe3"}[chunkId] + ".js";
};